import i18n from "@/lib/i18n";
import * as React from "react";

interface FlexibleNotesSectionProps {
  notes: string;
  title?: string;
  className?: string;
}

export const FlexibleNotesSection: React.FC<FlexibleNotesSectionProps> = ({
  notes,
  title = i18n.t("features.quotes.quoteViewer.sections.flexibleNotesSection.additionalNotes"),
  className,
}) => (
  <div className={`border border-slate-200 rounded-lg ${className || ""}`}>
    <div className="bg-slate-50 border-b border-slate-200 px-6 py-4">
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
    </div>
    <div className="p-6">
      <div className="bg-amber-50 border-l-4 border-amber-200 p-4 rounded">
        <p className="whitespace-pre-line text-slate-700 leading-relaxed">
          {notes}
        </p>
      </div>
    </div>
  </div>
);
